import { LeafDatetime } from "./datetime.component.js";
customElements.define("leaf-datetime", LeafDatetime);
export {
  LeafDatetime
};
//# sourceMappingURL=datetime.js.map
